import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import "vuetify/dist/vuetify.min.css";
import Vue2Editor from "vue2-editor";

// Vue tel input
import VueTelInput from "vue-tel-input";

Vue.use(VueTelInput);

// Libraries components
import "./imports/bootstrap";
import "./imports/font-awesome";

// Application global style
import custom from "./assets/custom.scss";
import table from "./assets/table.scss";

// Application global routes
// import ROUTES from "./assets/routes.js";

// vue-multiselect component
import "vue-multiselect/dist/vue-multiselect.min.css";
import Multiselect from "vue-multiselect";

// Attacher les constantes de routes à l'application
// App.config.globalProperties.$ROUTES = ROUTES;

Vue.component("multiselect", Multiselect);

// vue-i18n
import VueI18n from "vue-i18n";
import i18n from "./i18n";
Vue.use(VueI18n);

// axios
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (err) => {
    if (
      err.response.data.status_code == 401 &&
      err.response.data.message === "Unauthenticated." &&
      store.state.token
    ) {
      store.dispatch("logout");
    } else {
      store.state.error = err.response.data.message;
      // store.state.showError = true
      return Promise.reject(err);
    }
  }
);

// VueMce
import VueMce from "vue-mce";

import vuetify from "./plugins/vuetify";
Vue.use(VueMce);

// ApexCharts
import VueApexCharts from "vue-apexcharts";
Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);

Vue.config.productionTip = false;
Vue.use(Vue2Editor);

Vue.use(custom, table);

// Prevent Google Translate from being applied
// This ensures only backend translations (vue-i18n) are used
(function() {
  // Block Google Translate API if it tries to load
  if (typeof window.google !== 'undefined' && window.google.translate) {
    window.google.translate.TranslateElement = function() {};
  }
  
  // Remove translate attribute from body/html if added by browser extension
  document.addEventListener('DOMContentLoaded', function() {
    document.body.setAttribute('translate', 'no');
    document.documentElement.setAttribute('translate', 'no');
    
    // Continuously remove Google Translate elements
    const removeGoogleTranslate = setInterval(function() {
      // Remove Google Translate iframes
      const translateFrames = document.querySelectorAll('iframe[src*="translate.google"], iframe[src*="translate.googleapis.com"]');
      translateFrames.forEach(function(frame) {
        frame.remove();
      });
      
      // Remove Google Translate banners and popups
      const translateElements = document.querySelectorAll(
        '.goog-te-banner-frame, .goog-te-balloon-frame, #google_translate_element, .skiptranslate, .goog-te-menu-frame'
      );
      translateElements.forEach(function(element) {
        element.remove();
      });
      
      // Ensure body doesn't have translate class added by Google Translate
      if (document.body.classList.contains('translated-ltr') || document.body.classList.contains('translated-rtl')) {
        document.body.classList.remove('translated-ltr', 'translated-rtl');
      }
    }, 100);
    
    // Clean up interval when page unloads
    window.addEventListener('beforeunload', function() {
      clearInterval(removeGoogleTranslate);
    });
  });
})();

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
